import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

import Checkbox from '@material-ui/core/Checkbox';

import { Button, Upload } from "antd";
import { ExcelRenderer } from "react-excel-renderer";

import $ from "jquery";
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class MemberAuto extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            user_permission: user_permission,
            cols: [],
            rows: [],
            errorMessage: null,
            userid: user_id,
            pages: [],
            project_home: [],
            addIsOpen: false,
            srcIsOpen: false,
            importIsOpen: false,
            deleteIsOpen: false,
            updateIsOpen: false,
            content_id: '',
            methodOpen: '',
            jwt: jwt,
            add_id: '',
            add_house_no: '',
            add_plot: '',
            add_owner: '',
            add_project: '',
            add_delivery: '',
            add_expire: '',
            add_active_status: '',
            add_img: '',
            src_house_no: "",
            src_project: "",
            src_plot: "",
            src_owner: '',
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            add_residenceAll: "",
            file: null,
            residenceAll: [],
            page: 0,
            rowsPerPage: 10,
            count:0,
            counteErr: 0,
            IsVerify: false,
            import_count:0,
            miss_su: helpers.getUserType(user_type, "su"),
            columns: [
                {
                    title: "NAME",
                    dataIndex: "project_name"
                },
                {
                    title: "AGE",
                    dataIndex: "age"
                },
                {
                    title: "GENDER",
                    dataIndex: "gender"
                }
            ],
            IsVerify: false
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.openImport = this.openImport.bind(this);
        this.closeImport = this.closeImport.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.openEdit = this.openEdit.bind(this);
        this.openView = this.openView.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.submitEdit = this.submitEdit.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.submitImport = this.submitImport.bind(this);
        this.submitVerify = this.submitVerify.bind(this);

        this.handleCheck = this.handleCheck.bind(this)

        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);

        this.onChange = this.onChange.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);


        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)

        this.changeProjectName = this.changeProjectName.bind(this)
        this.project_home()
        this.dataTable();

    }

    project_home() {
        try {
            let body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                body = `?projecthomeid=${this.state.PROJECTID}`
                fetch(config.url.API_URL + '/project_homes/' + body, requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
            } else {
                fetch(config.url.API_URL + '/project_homes/', requestOptions)
                    .then(res => res.json())
                    .then(data => {
                        let sortData = data.data.sort(function (a, b) {
                            return a.num - b.num;
                        });
    
                        var found = sortData.filter(function (item) { return item.active; });
                        var found2 = found.filter(function (item) { return !item.delete; });
    
                        let FromApi = found2.map(data => {
                            return { value: data.id, display: data.name_th }
                        });
    
                        this.setState({
                            project_home: [{ value: '', display: 'เลือกโครงการ' }].concat(FromApi)
                        });
                    }).catch(error => {
                        console.log(error)
                        //window.location.reload(); // Reload the page
                    });
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            let project_id = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                project_id = this.state.PROJECTID
            } else {
                project_id = ``
            }
            let body = `?projecthomeid=${project_id}`
    
            fetch(config.url.API_URL + '/membersverify/' + body, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data
                    this.setState({
                        pages: [].concat(data)
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTableSrc() {
        try {
            let project_id = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            if (this.state.PROJECTID) {
                project_id = this.state.PROJECTID
            } else {
                project_id = this.state.src_project
            }
    
            let body = `?projecthomeid=${project_id}&residenceid=${this.state.add_residenceAll}`
            
            fetch(config.url.API_URL + '/membersverify' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data)
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitSrc(e) {
        this.dataTableSrc()
        this.setState({ srcIsOpen: false });
    }

    submitImport() {
        try {
            if (!this.state.rows || this.state.rows.length === 0) {
                alert("ไม่มีข้อมูลการ import")
                return
            }
    
            if (!this.state.IsVerify) {
                alert("ยังไม่ได้ทำการตรวจสอบข้อมูล")
                return
            } else {

                const requestOptions = {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': this.state.jwt,
                    },
                    body: JSON.stringify({
                        import_data: this.state.rows,
                        createby: this.state.create_by,
                        createby_id: this.state.create_by_id
    
                    })
                };

                const batchSize = 100
                this.setState({import_count:0})
                const importBatch = async (start) => {
                    if (start >= this.state.rows.length) {
                        this.setState({
                            importIsOpen: false,
                            updateIsOpen: true,
                            spinner: false
                        });
                        return;
                    }
            
                    const batch = this.state.rows.slice(start, start + batchSize);
                    requestOptions.body = JSON.stringify({
                        import_data: batch,
                        createby: this.state.create_by,
                        createby_id: this.state.create_by_id
                    });
            
                    try {
                        const res = await fetch(config.url.API_URL + '/import_membersverifyNEW1', requestOptions);
                        const data = await res.json();
                        this.setState({import_count: this.state.import_count + data.data.length})
                    } catch (err) {
                        console.log(`error during import`)
                        console.log(err)
                        this.setState({
                            spinner: false,
                            updateIsOpen: false,
                        })
                    }
            
                    // Process next batch
                    importBatch(start + batchSize);
                }
            
                // Start importing batches
                importBatch(0);

                //-------------------------------------------------------------------------
                // const requestOptions = {
                //     method: 'POST',
                //     headers: {
                //         Accept: 'application/json',
                //         'Content-Type': 'application/json',
                //         'Authorization': this.state.jwt,
                //     },
                //     body: JSON.stringify({
                //         import_data: this.state.rows,
                //         createby: this.state.create_by,
                //         createby_id: this.state.create_by_id
    
                //     })
                // };
    
                // fetch(config.url.API_URL + '/import_membersverifyNEW', requestOptions)
                //     .then(res => res.json())
                //     .then(data => {
                //         this.setState({
                //             importIsOpen: false,
                //             updateIsOpen: true
                //         });
                //     }).catch(error => {
                //         console.log(error)
                //         this.setState({
                //             importIsOpen: false,
                //             updateIsOpen: false
                //         });
                //     }).catch(error => {
                //         console.log(error)
                //         //window.location.reload(); // Reload the page
                //     });
    
            }
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_house_no: '',
            add_plot: '',
            add_owner: '',
            add_project: '',
            add_delivery: '',
            add_expire: '',
            val_project: '',
            active: true
        });
    }

    openEdit(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/residences/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    debugger
                    this.setState({
                        add_id: data.id,
                        add_house_no: data.house_no,
                        add_plot: data.plot,
                        add_project: data.project_name,
                        val_project: data.project_home_id,
                        add_delivery: data.delivery_date === '' ? "" : new Date(data.edit_delivery_date),
                        add_expire: data.expired_insurance === '' ? "" : new Date(data.edit_expired_insurance),
                        view_address: data.address,
                        view_phone: data.customer_tell,
                        view_email: data.customer_email
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openImport() {
        this.setState({
            importIsOpen: true,
            rows: [],
            errorMessage: null,
            IsVerify: false,
            import_count:0

        });
    }

    closeImport() {
        this.setState({
            importIsOpen: false,
        });
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/residences/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data;
                    this.setState({
                        add_id: data.id,
                        add_house_no: data.house_no,
                        add_plot: data.plot,
                        add_project: data.project_name,
                        val_project: data.project_home_id,
                        add_delivery: data.delivery_date,
                        add_expire: data.expired_insurance,
                        view_address: data.address,
                        view_phone: data.customer_tell,
                        view_email: data.customer_email,
                        add_owner: data.ownerName,
                        add_active_status: data.active_status
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closeAdd() {
        this.setState({
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            src_house_no: "",
            src_project: "",
            src_plot: "",
            src_owner: '',
            residenceAll: [],
            add_residenceAll: "",
            page: 0
        });
    }

    submitAdd() {
        try {
            if (!this.state.val_project) {
                alert('ไม่พบข้อมูลชื่อโครงการ');
                return;
            }
    
            if (!this.state.add_house_no) {
                alert('ไม่พบข้อมูลบ้านเลขที่');
                return;
            }
    
            if (!this.state.add_plot) {
                alert('ไม่พบข้อมูลแปลง');
                return;
            }
    
            if (!this.state.active) {
                this.setState({
                    active: true
                })
            }
    
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    house_no: this.state.add_house_no,
                    plot: this.state.add_plot,
                    project_home_id: this.state.val_project,
                    delivery_date: this.state.add_delivery,
                    expired_insurance: this.state.add_expire,
                    active_status: this.state.active ? 1 : 0,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/residences', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/delete_residences/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                });
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitEdit(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    house_no: this.state.add_house_no,
                    plot: this.state.add_plot,
                    project_home_id: this.state.val_project,
                    delivery_date: this.state.add_delivery,
                    expired_insurance: this.state.add_expire,
                    active_status: this.state.active ? 1 : 0,
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/residences/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        addIsOpen: false
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    onChange(e) {
        this.setState({ file: e.target.files[0] });
    }

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    changeStartDate = date => {
        this.setState({
            add_delivery: date
        });
    }

    changeEndDate = date => {
        this.setState({
            add_expire: date
        });
    }

    changeProjectName(e) {
        this.setState({
            [e.target.name]: e.target.value,
            residenceAll: [],
            add_residenceAll:""
        });
        this.residence(e.target.value)
    }

    residence(project_home_id) {
        try {
            let body = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (project_home_id) {
                body = `?projecthomeid=${project_home_id}`
            }
            fetch(config.url.API_URL + '/residencesByProjectHome/' + body, requestOptions)
                .then(res => res.json())
                .then(data_res => {
                    var data = data_res.data;
                    let FromApi = data_res.data.residence.map(data => {
                        return { value: data.id, display: data.house_no }
                    });
                    this.setState({
                        residenceAll: [{ value: '', display: 'เลือกบ้านเลขที่' }].concat(FromApi),
                        add_residence: data.residence,
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
            return true
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    fileHandler = fileList => {
        console.log("fileList", fileList);
        let fileObj = fileList;
        if (!fileObj) {
            this.setState({
                errorMessage: "No file uploaded!"
            });
            return false;
        }
        console.log("fileObj.type:", fileObj.type);
        if (
            !(
                fileObj.type === "application/vnd.ms-excel" ||
                fileObj.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            )
        ) {
            this.setState({
                errorMessage: "Unknown file format. Only Excel files are uploaded!"
            });
            return false;
        }
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            } else {
                let newRows = [];
                resp.rows.slice(1).map((row, index) => {
                    if (row && row !== "undefined" && row.length > 0) {
                        newRows.push({
                            key: index,
                            project_name: row[0],
                            house_no: row[1],
                            member_idcard: row[2],
                        });
                    }
                }, {});
                if (newRows.length === 0) {
                    this.setState({
                        errorMessage: "No data found in file!"
                    });
                    return false;
                } else {
                    this.setState({
                        rows: newRows,
                        errorMessage: null
                    });
                }
            }
        });
        return false;
    };

    checkFile(file) {
        let errorMessage = "";
        if (!file || !file[0]) {
            return;
        }
        const isExcel =
            file[0].type === "application/vnd.ms-excel" ||
            file[0].type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        if (!isExcel) {
            errorMessage = "You can only upload Excel file!";
        }
        console.log("file", file[0].type);
        const isLt2M = file[0].size / 1024 / 1024 < 2;
        if (!isLt2M) {
            errorMessage = "File must be smaller than 2MB!";
        }
        console.log("errorMessage", errorMessage);
        return errorMessage;
    }

    submitVerify = async () => {
        try {
            if (!this.state.rows || this.state.rows.length === 0) {
                alert("ไม่มีข้อมูลการ import")
                return
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    import_data: this.state.rows,
                    createby: this.state.create_by,
                    createby_id: this.state.create_by_id
    
                })
            };

            // --------------------------------------------------------------------------------------

            const batchSize = 100;
            const failedArr = []
            const successArr = []
            let verify_failed = 0
    
            document.getElementById('submitverify_btn').disabled = true 
            for (let i = 0; i < this.state.rows.length; i += batchSize) {
    
    
                const batch = this.state.rows.slice(i, i + batchSize);
                const data = batch.map((item) => ({ ...item }));
                requestOptions.body = JSON.stringify({
                        import_data: data,
                        createby: this.state.create_by,
                        createby_id: this.state.create_by_id
                })
    
                try {
                    const res = await fetch(config.url.API_URL + '/verifyimport_membersNEW1', requestOptions);
                    const data = await res.json();
                    if (data.status === "Success") {
                        failedArr.push(...data.unsuccessData)
                        successArr.push(...data.successData)
                        data.invalid > 0 ? verify_failed += data.invalid : verify_failed += 0
    
                        this.setState({import_count: this.state.import_count + data.data.length})
                        console.log(failedArr)
                        console.log(successArr)
                    }else{
                        this.setState({
                            errorMessage: null,
                            IsVerify: false,
                        });
                        document.getElementById('submitverify_btn').disabled = false 
                    }
                } catch (error) {
                    console.log(error)
                    this.setState({
                        rows:[],
                        errorMessage: 'error cannot verify data',
                        IsVerify: false,
                        import_count:0
                    });
                    document.getElementById('submitverify_btn').disabled = false 
    
                }
            }
    
            const resultArr = [...failedArr,...successArr]
    
            this.setState({
                rows: resultArr,
                errorMessage: null,
                IsVerify: true,
                spinner: false
            });
    
            document.getElementById('submitverify_btn').disabled = false 

            // --------------------------------------------------------------------------------------
    
            // fetch(config.url.API_URL + '/verifyimport_membersNEW', requestOptions)
            //     .then(res => res.json())
            //     .then(data => {
            //         console.log(data)
            //         var dataArr = data.data
            //         if (dataArr) {
            //             alert("ตรวจสอบเรียบร้อย")
            //             this.setState({
            //                 rows: dataArr,
            //                 errorMessage: null,
            //                 // IsVerify: data.failed > 0 ? false : true
            //                 IsVerify: true
            //             });
            //         }
            //     }).catch(error => {
            //         console.log(error)
            //         //window.location.reload(); // Reload the page
            //     })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Member Verify List</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">member verify</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    <ExcelFile filename="memberauto" element={(this.state.user_permission[223].permission == 1 && <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="memberauto">
                                            <ExcelColumn label="โครงการ" value={(col) => col.project_homes[0].name_th} />
                                            <ExcelColumn label="บ้านเลขที่" value={(col) => col.residences[0].house_no} />
                                            <ExcelColumn label="รหัสบัตรประจำตัวประชาชน" value="member_idcard" />
                                            <ExcelColumn label="สถานะการอนุมัติ" value={(col) => col.approve_status == 0 ? "ยังไม่ได้อนุมัติ" : "อนุมัติแล้ว"} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby == undefined ? col.createby : col.updateby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(วันที่)" value={(col) => col.updated != undefined ? moment(col.updated).format("DD/MM/YYYY HH:mm") : moment(col.created).format("DD/MM/YYYY HH:mm")} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                    {(this.state.user_permission[224].permission == 1 &&
                                        // <div className="btn-add text-center" ><a href={'https://admin.nvdsmarthome.com/downloadFile/member_verify.xlsx'} style={{ color: 'black' }}>Download Template</a></div>
                                        <div className="btn-add text-center" ><a href={`${config.url.API_URL}/downloadFile/member_verify.xlsx`} style={{ color: 'black' }}>Download Template</a></div>
                                    )}
                                    {(this.state.user_permission[222].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openImport}>Import</div>
                                    )}
                                    {/* {(this.state.user_permission[18].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )} */}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>รหัสบัตรประจำตัวประชาชน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะการอนุมัติ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>วันที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    {/* <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{i + 1}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_homes.length > 0 ? data.project_homes[0].name_th : ""}</StyledTableCell>
                                                                    <StyledTableCell>{data.residences.length > 0 ? data.residences[0].house_no : ""}</StyledTableCell>
                                                                    <StyledTableCell>{data.member_idcard}</StyledTableCell>
                                                                    <StyledTableCell>{data.approve_status == 0 ? "ยังไม่ได้อนุมัติ" : "อนุมัติแล้ว"}</StyledTableCell>
                                                                    <StyledTableCell>{data.updated != undefined ? moment(data.updated).format("DD/MM/YYYY HH:mm") : moment(data.created).format("DD/MM/YYYY HH:mm")}</StyledTableCell>
                                                                    <StyledTableCell>{data.updateby == undefined ? data.createby : data.updateby}</StyledTableCell>
                                                                    {/* <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                        {(this.state.user_permission[19].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                        )}
                                                                        {(this.state.user_permission[20].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        )}
                                                                    </StyledTableCell> */}
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ :</div>
                                <div className="col-sm-5">
                                    <select className="form-control" id="src_project" name="src_project" style={{ height: 45 }} onChange={this.changeProjectName}>
                                        {this.state.project_home.map((datas, i) => <option key={i} value={datas.value}>{datas.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right" >บ้านเลขที่</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="add_residenceAll" onChange={this.change}>
                                        {this.state.residenceAll.map((data, i) => <option key={i} value={data.value}>{data.display}</option>)}
                                    </select>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">โครงการ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-5">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" id="val_project" name="val_project" style={{ height: 45 }} onChange={this.change}>
                                            {this.state.project_home.map((datas) =>
                                                <option value={datas.value} selected={this.state.val_project === datas.value && "selected"}>{datas.display}</option>
                                            )}
                                        </select>) : (<div className="form-control">{this.state.add_project}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">บ้านเลขที่<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_house_no" name="add_house_no" defaultValue={this.state.add_house_no} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_house_no}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">แปลง<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-5">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_plot" name="add_plot" defaultValue={this.state.add_plot} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_plot}</div>)}
                                </div>
                            </div>
                            {this.state.methodOpen === 'view' && (<div className="row mb-3">
                                <div className="col-sm-3 text-right">ที่อยู่ :</div>
                                <div className="col-sm-5">
                                    <TextareaAutosize className="form-control" aria-label="minimum height" name="view_address" rowsMin={1} defaultValue={this.state.view_address} disabled />
                                </div>
                            </div>)}
                            {this.state.methodOpen === 'view' && (<div className="row mb-3">
                                <div className="col-sm-3 text-right">เจ้าบ้าน :</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.add_owner}</div>
                                </div>
                            </div>)}
                            {this.state.methodOpen === 'view' && (<div className="row mb-3">
                                <div className="col-sm-3 text-right">เบอร์ติดต่อ :</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.view_phone}</div>
                                </div>
                            </div>)}
                            {this.state.methodOpen === 'view' && (<div className="row mb-3">
                                <div className="col-sm-3 text-right">อีเมล :</div>
                                <div className="col-sm-5">
                                    <div className="form-control">{this.state.view_email}</div>
                                </div>
                            </div>)}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">วันที่รับมอบบ้าน</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_delivery} id="add_delivery" onChange={this.changeStartDate} name="add_delivery" className="form-control" dateFormat="dd/MM/yyyy" />)
                                        : (<div className="form-control">{this.state.add_delivery}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หมดอายุประกัน</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_expire} id="add_expire" onChange={this.changeEndDate} name="add_expire" className="form-control" dateFormat="dd/MM/yyyy" />)
                                        : (<div className="form-control">{this.state.add_expire}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>

                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.importIsOpen} onHide={this.closeImport} size="xl">
                    <ModalHeader>
                        <div className="row">
                            <div className="col-sm-12">
                                <Upload name="file" beforeUpload={this.fileHandler} onRemove={() => this.setState({ rows: [] })} multiple={false} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" >
                                    <Button className="btn btn-primary" disabled={this.state.rows.length > 0 ? true : false}> Import Excel File </Button>
                                </Upload>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>โครงการ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>รหัสบัตรประจำตัวประชาชน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หมายเหตุ</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.rows.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell>{data.project_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.house_no}</StyledTableCell>
                                                                    <StyledTableCell>{data.member_idcard}</StyledTableCell>
                                                                    <StyledTableCell>{data.remark == undefined ? "" : data.remark}</StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.rows.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                        <button className="btn btn-warning" id='submitverify_btn' onClick={this.submitVerify}>ตรวจสอบข้อมูล</button>
                        &nbsp;&nbsp;
                            <button className="btn btn-danger" onClick={this.closeImport}>ยกเลิก</button>
                        &nbsp;&nbsp;
                            <button className="btn btn-success" disabled={!this.state.IsVerify} data-id={this.state.add_id} onClick={this.submitImport}>ตกลง</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}